window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderRows = parseInt(e.dataset.sliderRows),
      sliderGrid = "column",
      // [LOOP] Il ciclo infinito era SPENTO su piu' sezioni senza che si vedesse
      // il perche': qui si leggeva solo `data-loop`, ma diverse sezioni del
      // tema dichiarano `data-slide-loop` (lo slider categorie in homepage,
      // per esempio, ha data-slide-loop="true"). Nomi diversi per la stessa
      // cosa: il valore arrivava undefined e il ciclo restava disattivato,
      // da cui i vuoti alla fine della lista. Ora si accettano entrambi.
      sliderLoop = e.dataset.loop || e.dataset.slideLoop;

    if (sliderLoop === "true") {
      sliderLoop = true;
    } else {
      sliderLoop = false;
    }

    if (sliderRows > 1) {
      sliderGrid = "row";
      sliderLoop = false;
    }
    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      largeDesktopShow = parseInt(e.dataset.showLarge);
      tabletShow = parseInt(e.dataset.showTablet);
      mobileShow = parseInt(e.dataset.showMobile);
    }

    if (e.dataset.shuffleSlides === "true" && sliderContainer) {
      var sw = sliderContainer.querySelector('.swiper-wrapper');
      if (sw && sw.children.length > 1) {
        var sl = Array.from(sw.children);
        for (var i = sl.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = sl[i]; sl[i] = sl[j]; sl[j] = t;
        }
        sl.forEach(function(n) { sw.appendChild(n); });
      }
    }

    // [CAT] Slider categorie: numero di elementi calcolato dallo spazio
    // disponibile invece che fissato per fascia di schermo.
    // Con un numero fisso, la larghezza di ogni casella e' spazio diviso N:
    // su un monitor grande le caselle si allargano e, a cerchio fisso, lo
    // spazio vuoto cresce; rimpicciolendo il cerchio per riempire si perde la
    // dimensione. Con "auto" il rapporto si inverte: il cerchio ha una misura
    // fissa (nel CSS) e Swiper calcola quanti ce ne stanno. Cosi' le icone
    // restano grandi uguali su ogni schermo e cambia solo quante se ne vedono.
    var isCategorie = !!(e.closest && e.closest(".product__categories--section"));
    var perView = isCategorie ? "auto" : mobileShow;
    var gap = isCategorie ? 14 : 20;

    // Con slidesPerView "auto" Swiper non sa quante copie servono per chiudere
    // il cerchio: senza un margine di slide duplicate, scorrendo veloce si
    // aprono buchi bianchi prima che il ciclo si ricomponga. loopedSlides le
    // prepara in anticipo, una per ogni categoria presente.
    var loopExtra = {};
    if (isCategorie && sliderLoop) {
      var nSlide = sliderContainer
        ? sliderContainer.querySelectorAll(".swiper-slide").length
        : 0;
      loopExtra = {
        loopedSlides: Math.max(nSlide, 10),
        loopAdditionalSlides: Math.max(nSlide, 10),
        watchSlidesProgress: true,
      };
    }

    var swiper = new Swiper(sliderContainer, Object.assign({
      loop: sliderLoop,
      slidesPerView: perView,
      spaceBetween: gap,
      grid: {
        rows: sliderRows,
        fill: sliderGrid,
      },
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: e.querySelector(".product_slider_wrapper .swiper-button-next"),
        prevEl: e.querySelector(".product_slider_wrapper .swiper-button-prev"),
      },
      breakpoints: isCategorie
        ? {
            640: { slidesPerView: "auto" },
            750: { slidesPerView: "auto" },
            992: { slidesPerView: "auto" },
            1200: { slidesPerView: "auto" },
          }
        : {
            640: {
              slidesPerView: mobileShow,
            },
            750: {
              slidesPerView: tabletShow,
            },
            992: {
              slidesPerView: largeDesktopShow,
            },
            1200: {
              slidesPerView: extraLargeDesktopShow,
            },
          },
    }, loopExtra));
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return sliderProduct;
})();

/* NIDO: shuffle random prodotti homepage (esclusa sezione "Nuovi arrivi")
 * Funzione condivisa e riutilizzabile: riordina in modo random (Fisher-Yates) i figli
 * diretti di ogni contenitore marcato con data-shuffle-products="true" nel markup Liquid
 * (vedi sections/featured-collection.liquid). Ogni sezione viene shufflata in modo
 * indipendente (non mescola prodotti tra sezioni diverse). Gira lato client ad ogni
 * DOMContentLoaded, quindi l'ordine cambia ad ogni caricamento pagina reale, senza
 * bisogno di bypassare la cache CDN di Shopify e senza toccare l'HTML server-rendered
 * (che resta invariato per SEO/crawler). Limite noto: se una sezione carica altri
 * prodotti via "load more"/paginazione AJAX, il nuovo batch NON viene rimescolato
 * automaticamente (nessuna delle sezioni homepage attuali usa load more, quindi non è
 * un problema oggi, ma va tenuto a mente se in futuro si abilita quella modalità).
 */
theme.shuffleProductGrids = function shuffleProductGrids() {
  document.querySelectorAll('[data-shuffle-products="true"]').forEach(function (grid) {
    if (grid.dataset.shuffled === "true") return;
    var items = Array.from(grid.children);
    if (items.length < 2) return;
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = items[i];
      items[i] = items[j];
      items[j] = t;
    }
    items.forEach(function (node) {
      grid.appendChild(node);
    });
    grid.dataset.shuffled = "true";
  });
};

document.addEventListener("DOMContentLoaded", function () {
  // Shuffle random delle griglie prodotto (fatto per primo, prima di qualunque
  // inizializzazione di slider/observer che potrebbe dipendere dall'ordine del DOM).
  theme.shuffleProductGrids();

  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  sections.register("header", theme.headerCategoryMenu);
  headerSearchModule.register("header", theme.headerSearch);
  headerStickyModule.register("header", theme.headerSticky);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("product-tab", theme.productTab);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("counter_up", theme.counterup);
  sections.register("faq-collapse", theme.accordion);
  sections.register("popup-video", theme.video);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});
